import styled from 'styled-components';
import { BtnBlue, BtnGhost } from '../Button';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

const Root = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5010;
  opacity: 0;
  transition: all 0.3s ease;
  visibility: hidden;
  pointer-events: none;

  &.active {
    background-color: rgba(0, 0, 0, 0.5);
    visibility: visible;
    pointer-events: auto;
    opacity: 1;
  }

  > div {
    height: 100%;
  }

  .modal {
    width: 24rem !important;
    max-height: 50vh;
    height: calc(100vh - 150px) !important;
    border-radius: 1rem;
    background: var(--board);
    transform: translateY(40px);
    transition: all 0.3s ease;

    &.active {
      transform: translateY(0);
    }

    @media screen and (max-width: 768px) {
      & {
        position: absolute;
        bottom: 0;
        width: 100% !important;
        height: 70vh !important;
        max-height: initial;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        transform: translateY(100%);
      }

      &.active {
        transform: translateY(0);
      }
    }

    .inputForm-head {
      display: flex;
      width: 100%;
      justify-content: space-between;
      padding: 0.5rem 1rem;
      border-bottom: 1px solid var(--outline);

      .medium {
        display: flex;
        align-items: center;
        font-size: 1rem;

        span {
          font-size: 22px;
        }
      }

      .close-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        height: auto;
        padding: 0;
      }
    }

    .inputForm-body {
      display: flex;
      flex-direction: column;
      height: calc(100% - 52px);

      .filter-option-wrapper {
        height: -webkit-fill-available;
        padding: 0 1rem;
        overflow-y: auto;

        .filter-option-date {
          padding: 24px 0;

          .flex-basic {
            background: var(--tonal);

            input {
              text-align: center;
            }
          }
        }

        .filter-option-col {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .filter-option-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        }

        .filter-underline {
          border-bottom: 1px solid var(--outline);
        }

        .filter-option-cont {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          padding: 1.5rem 0;
        }

        .filter-chk {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
          padding: 1rem 0;
        }
      }

      .modal-footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem;
        gap: 0.5rem;
        border-top: 1px solid var(--outline);

        .filter-search-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          height: 3rem;
          gap: 0.25rem;
        }

        .filter-reset-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 3rem;
          height: 3rem;
          padding: 0;
          border: 1px solid var(--outline);
          border-radius: 0.5rem;
        }
      }
    }
  }
`;

interface Props {
  children: React.ReactNode;
  openModal?: any;
  setOpenModal: any;
  title?: string;
}

const AttrFilterModal = ({ children, openModal, setOpenModal, title = '속성 필터' }: Props) => {
  const { t } = useTranslation();
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (openModal?.status && openModal?.type === 'attrFilter') {
      requestAnimationFrame(() => {
        modalRef.current?.classList.add('active');
      });
    } else {
      modalRef.current?.classList.remove('active');
    }
  }, [openModal?.status]);

  const onClickClose = () => {
    modalRef.current?.classList.remove('active');
    setOpenModal({ status: false, type: 'filter' });
  };

  return (
    <Root role='presentation' className={`${openModal?.status && openModal?.type === 'attrFilter' ? 'active' : ''}`} onClick={onClickClose}>
      <div
        role='presentation'
        className='modal'
        ref={modalRef}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <div className='inputForm-head'>
          <h5 className='medium'>
            <span className='material-symbols-rounded'>discover_tune</span>
            {t(title)}
          </h5>
          <BtnGhost onClick={onClickClose} className='close-btn'>
            <span className='material-symbols-rounded'>close</span>
          </BtnGhost>
        </div>
        <div className='inputForm-body'>
          {children}
          {/* <div className='modal-footer flex-end'>
            <BtnBlue className='filter-search-btn' onClick={onClickSubmit}>
              적용
            </BtnBlue>
            <BtnGhost className='filter-reset-btn' onClick={onClickReset}>
              <span className='material-symbols-rounded'>cached</span>
            </BtnGhost>
          </div> */}
        </div>
      </div>
    </Root>
  );
};

export default AttrFilterModal;
